import { USER_TYPE } from '@plataforma/utils';

const tasks = [
  'ADMINISTRAR_TOMADORES',
  'ADMINISTRAR_USUARIOS',
  'ADMINISTRAR_ASSESSORIA',
  'PROCESSOS_USUARIO',
  'DADOS_CORRETORA',
  'RELATORIO_TOMADOR',
  'LOGOUT',
  'TROCAR_CORRETOR',
  'LOGOUT_SUPER_USER'
];

const permissionsByUserProfile = {
  ADMINISTRAR_TOMADORES: [USER_TYPE.broker],
  ADMINISTRAR_USUARIOS: [USER_TYPE.broker],
  ADMINISTRAR_ASSESSORIA: [USER_TYPE.broker],
  DADOS_CORRETORA: [USER_TYPE.broker],
  PROCESSOS_USUARIO: [USER_TYPE.broker],
  RELATORIO_TOMADOR: [USER_TYPE.broker],
  TROCAR_CORRETOR: [USER_TYPE.commercial],
  LOGOUT: [USER_TYPE.broker, USER_TYPE.policyholder],
  LOGOUT_SUPER_USER: [USER_TYPE.commercial]
};

/**
 * showMenuItem
 * Return the menu item based on a comparsion from the userProfile and task name
 *
 * @param {String} userProfile - the user profile returned by getUserProfile() from Authentication
 * @param {String} task - the menu task name
 */
export const showMenuItem = (userProfile, task) => {
  if (!task || !tasks.includes(task)) return false;

  return permissionsByUserProfile[task].includes(userProfile);
};

export default showMenuItem;
